<template>
  <div>
    <div class="pass-box" @click="handleEditPassword">
      <i class="iconfont iconqita-2yanzhengma_1"></i>
      权限密钥
    </div>
    <el-dialog
      title="修改密钥"
      :visible="visible"
      @close="visible = false"
      @closed="reset"
      width="380px"
      :close-on-click-modal="false"
    >
      <el-form ref="passForm" :rules="keyRules" :model="key" label-width="80px">
        <el-form-item prop="oldPassword" label="原密钥">
          <el-input type="password" v-model.trim="key.oldPassword" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item prop="password" label="新密钥">
          <el-input type="password" v-model.trim="key.password" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item prop="confirmPassword" label="确认密钥">
          <el-input
            type="password"
            v-model.trim="key.confirmPassword"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="handleOk" :loading="btnLoading">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validatePassApi from 'api/home/validatePass';
import md5 from 'js-md5';
export default {
  data() {
    return {
      visible: false,
      btnLoading: false,
      key: {
        oldPassword: '',
        password: '',
        confirmPassword: ''
      },
      keyRules: {
        oldPassword: [{ required: true, max: 20, message: '必填项，长度小于20', trigger: 'blur' }],
        password: [{ required: true, max: 20, message: '必填项，长度小于20', trigger: 'blur' }],
        confirmPassword: [
          {
            required: true,
            validator: this.validatePass2,
            trigger: 'blur'
          }
        ]
      }
    };
  },
  methods: {
    handleEditPassword() {
      this.visible = true;
    },
    handleOk() {
      this.$refs.passForm.validate(validated => {
        if (!validated) {
          return;
        }
        const { oldPassword, password, confirmPassword } = this.key;
        const data = {
          oldPassword: md5(oldPassword),
          password: md5(password),
          confirmPassword: md5(confirmPassword)
        };
        // console.log(data);
        this.btnLoading = true;
        validatePassApi
          .editValidatePass(data)
          .then(res => {
            if (!res.success) {
              return;
            }
            this.$message.success('修改成功');
            this.visible = false;
          })
          .finally(() => {
            this.btnLoading = false;
          });
      });
    },
    reset() {
      this.$refs.passForm.resetFields();
    },
    //密码一致性判断
    validatePass2(rule, value, callback) {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.key.password) {
        callback(new Error('两次输入密码不一致!'));
      } else if (value.length > 20) {
        callback(new Error('长度小于20'));
      } else {
        callback();
      }
    }
  }
};
</script>
<style lang="less" scoped>
.pass-box {
  cursor: pointer;
}
</style>